// import axios from "axios";
import secure_axios from "../../services/secure_axios";

const initialState = () =>({
  allProducts: [],
  thisProduct: "",
  selectedProducts: [],
  soStatus: ""
});

const state = initialState();
const getters = {
  allProducts: (state) => state.allProducts,
  thisProduct: (state) => state.thisProduct,
  selectedProducts: (state) => state.selectedProducts,
  soStatus: (state) => state.soStatus
};

const mutations = {
  setAllProducts(state, payload) {
    state.allProducts = payload;
  },
  setThisProduct(state, payload) {
    state.thisProduct = payload;
  },
  addThisProduct(state, payload) {
    state.selectedProducts.push(payload);
  },
  removeThisProduct(state, payload) {
    const stkdoc = payload.STKMST_DOCNO
    state.selectedProducts = state.selectedProducts.filter(function( stock ) {
      return stock.STKMST_DOCNO !== stkdoc;
    });
  },
  setSoStatus(state,payload){
    state.soStatus=payload;
  },
  clearThisProductsList(state) {
    if (state.soStatus == "success"){
    state.selectedProducts = [];
    }
  }, 
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getAllProducts({ commit, getters }, payload) {
    commit("setAllProducts", []);
    commit("setLoading", true);
    commit("clearError");

    const search = payload.search;
    const doctype = payload.doctype;
    const docno = payload.docno;

    secure_axios
      .get(
        `${getters.sessionAPI}products?search=${search}&doctype=${doctype}&docno=${docno}`
      )
      .then((response) => {
        commit("setAllProducts", response.data.products);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },
  selectThisProduct({ commit }, payload) {
    commit("setThisProduct", payload);
  },
  addProductToList({ state, commit }, payload) {
    const stkdoc = state.selectedProducts.filter(
      (product) => product.STKMST_DOCNO == payload.STKMST_DOCNO
    );
    if (stkdoc.length == 0) {
      commit("addThisProduct", payload);
      console.log(stkdoc);
    } else {
      console.log("Product already added");
    }
  },
  removeProductFromList({ commit }, payload) {
    commit("removeThisProduct", payload)
  },
  setSoStatus({commit},payload) {
    commit("setSoStatus", payload)
      // if(payload === 'success') commit("clearThisProductsList");
  },
  clearProductsList({ commit }) {
    setTimeout(commit("clearThisProductsList"),1000);   
  },  
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
